import React, { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Card } from '../../components/ui/card';
import { Radio, Save } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../utils/api';

const LivestreamManager = () => {
  const [formData, setFormData] = useState({
    title_en: 'Sunday Divine Liturgy - Live',
    title_ti: 'ሰንበት ቅዳሴ - ቀጥታ',
    stream_url: '',
    is_live: false
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/admin/livestream', formData);
      toast.success('Livestream settings saved!');
    } catch (error) {
      toast.error('Failed to save livestream settings');
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">Manage Live Stream</h2>
      
      <Card className="p-6">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium mb-2">YouTube Live Stream URL</label>
            <Input
              value={formData.stream_url}
              onChange={(e) => setFormData({...formData, stream_url: e.target.value})}
              placeholder="https://www.youtube.com/embed/live_stream?channel=YOUR_CHANNEL_ID"
              required
            />
            <p className="text-xs text-gray-500 mt-1">
              Enter your YouTube live stream embed URL
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-2">Title (English)</label>
              <Input
                value={formData.title_en}
                onChange={(e) => setFormData({...formData, title_en: e.target.value})}
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-2">Title (Tigrinya)</label>
              <Input
                value={formData.title_ti}
                onChange={(e) => setFormData({...formData, title_ti: e.target.value})}
                required
              />
            </div>
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              id="is_live"
              checked={formData.is_live}
              onChange={(e) => setFormData({...formData, is_live: e.target.checked})}
              className="mr-2"
            />
            <label htmlFor="is_live" className="text-sm font-medium">
              Set as Live Now (shows LIVE badge on website)
            </label>
          </div>

          <Button type="submit" className="bg-red-600 hover:bg-red-700">
            <Save className="w-4 h-4 mr-2" />
            Save Livestream Settings
          </Button>
        </form>

        <div className="mt-8 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
          <h4 className="font-bold mb-2">How to get your YouTube Live Stream URL:</h4>
          <ol className="list-decimal list-inside space-y-1 text-sm">
            <li>Go to YouTube Studio</li>
            <li>Click "Go Live"</li>
            <li>Copy your stream URL or Channel ID</li>
            <li>Format: https://www.youtube.com/embed/live_stream?channel=YOUR_CHANNEL_ID</li>
          </ol>
        </div>
      </Card>
    </div>
  );
};

export default LivestreamManager;
